function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Button, Icon, InputNumber } from 'mkui-fd';
import CurrencyDisabledView from './CurrencyDisabledView';
import CurrencyInput from '../currency-input';
import { Decimal } from 'decimal.js';
import PropTypes from 'prop-types';
import React from 'react';

var CurrencyAdjustAmount = /*#__PURE__*/function (_React$Component) {
  _inherits(CurrencyAdjustAmount, _React$Component);

  /** *******************static************************** */

  /** *******************life cycle************************** */
  function CurrencyAdjustAmount(props) {
    var _this;

    _classCallCheck(this, CurrencyAdjustAmount);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurrencyAdjustAmount).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "mathSignChangeHandle", function () {
      var amount = _this.props.amount;
      var mathSign = _this.state.mathSign;
      var adjustAmount = _this.adjustAmount;
      var precision = _this.props.precision;
      var number = 0;

      if (mathSign === 'balance') {
        number = parseFloat(new Decimal(amount).add(new Decimal(adjustAmount))).toFixed(precision);

        _this.setState({
          mathSign: 'plus'
        });
      } else {
        number = parseFloat(new Decimal(amount).minus(new Decimal(adjustAmount))).toFixed(precision);

        _this.setState({
          mathSign: 'balance'
        });
      }

      _this._setAmount(adjustAmount, number);
    });

    _defineProperty(_assertThisInitialized(_this), "adjustAmountChangeHandle", function (value) {
      if (isNaN(value)) return false;

      var number = _this._countAmount(value, 'adjust');

      _this._setAmount(value, number);
    });

    _defineProperty(_assertThisInitialized(_this), "adjustedAmountChangeHandle", function (value) {
      if (isNaN(value)) return false;

      var number = _this._countAmount(value, 'adjusted');

      _this._setAmount(number, value);
    });

    _this._initState();

    return _this;
  }
  /** *******************handle************************** */


  _createClass(CurrencyAdjustAmount, [{
    key: "_countAmount",

    /** *******************inner method************************** */
    value: function _countAmount(value, type) {
      var _this$props = this.props,
          amount = _this$props.amount,
          precision = _this$props.precision;
      var mathSign = this.state.mathSign;
      var number = 0;

      if (type === 'adjust') {
        if (mathSign === 'balance') {
          number = parseFloat(new Decimal(amount).minus(new Decimal(value))).toFixed(precision);
        } else {
          number = parseFloat(new Decimal(amount).add(new Decimal(value))).toFixed(precision);
        }
      } else {
        if (mathSign === 'plus') {
          number = parseFloat(new Decimal(value).minus(new Decimal(amount))).toFixed(precision);
        } else {
          number = parseFloat(new Decimal(amount).minus(new Decimal(value))).toFixed(precision);
        }
      }

      return number;
    }
  }, {
    key: "_setAmount",
    value: function _setAmount(val1, val2) {
      this.adjustAmount = val1;
      this.props.onChange(val2);
    }
  }, {
    key: "_initState",
    value: function _initState() {
      var adjustedAmount = this.props.value;
      var _this$props2 = this.props,
          amount = _this$props2.amount,
          precision = _this$props2.precision;
      var adjustAmount, mathSign;

      if (adjustedAmount || adjustedAmount === 0) {
        if (amount >= adjustedAmount) {
          mathSign = 'balance';
          adjustAmount = parseFloat(new Decimal(amount).minus(new Decimal(adjustedAmount))).toFixed(precision);
        } else {
          mathSign = 'plus';
          adjustAmount = parseFloat(new Decimal(adjustedAmount).minus(new Decimal(amount))).toFixed(precision);
        }
      }

      this.state = {
        mathSign: mathSign
      };
      this.adjustAmount = adjustAmount;
    }
    /** *******************render************************** */

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          precision = _this$props3.precision,
          disabled = _this$props3.disabled,
          amount = _this$props3.amount,
          ccyCode = _this$props3.ccyCode,
          min = _this$props3.min,
          max = _this$props3.max;
      var adjustedAmount = this.props.value;
      var mathSign = this.state.mathSign;

      if (mathSign === 'balance' && !isNaN(amount) && !isNaN(adjustedAmount)) {
        this.adjustAmount = parseFloat(new Decimal(amount).minus(new Decimal(adjustedAmount))).toFixed(precision);
      } else {
        this.adjustAmount = parseFloat(new Decimal(adjustedAmount).minus(new Decimal(amount))).toFixed(precision);
      }

      var adjustAmount = this.adjustAmount;
      return React.createElement("div", {
        className: "mkui-adjust-amount"
      }, !disabled && React.createElement("div", null, React.createElement("div", {
        className: "adjust-item"
      }, React.createElement("div", {
        className: "item-control-warpper"
      }, React.createElement(CurrencyInput, {
        precision: precision,
        value: amount,
        disabled: true,
        size: "large",
        symbol: ccyCode
      }))), React.createElement("div", {
        className: "math-sign"
      }, React.createElement(Button, {
        onClick: this.mathSignChangeHandle
      }, React.createElement(Icon, {
        type: mathSign,
        theme: "outlined"
      }))), React.createElement("div", {
        className: "adjust-item"
      }, React.createElement("div", {
        className: "item-control-warpper"
      }, React.createElement(InputNumber, {
        value: adjustAmount,
        onChange: this.adjustAmountChangeHandle,
        theme: "surround",
        precision: precision,
        placeholder: "0.00",
        min: min,
        max: max
      }))), React.createElement("div", {
        className: "math-sign"
      }, React.createElement(Icon, {
        type: "right",
        theme: "outlined"
      })), React.createElement("div", {
        className: "adjust-item"
      }, React.createElement("div", {
        className: "item-control-warpper"
      }, React.createElement(InputNumber, {
        value: adjustedAmount,
        onChange: this.adjustedAmountChangeHandle,
        theme: "surround",
        precision: precision,
        min: min,
        max: max
      })))), disabled && React.createElement(CurrencyDisabledView, {
        ccyCode: ccyCode,
        adjustedAmount: this.props.value,
        amount: this.props.amount,
        precision: precision
      }));
    }
  }]);

  return CurrencyAdjustAmount;
}(React.Component);

_defineProperty(CurrencyAdjustAmount, "propTypes", {
  prefixCls: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.number,
  amount: PropTypes.number,
  ccyCode: PropTypes.string,
  onChange: PropTypes.func
});

_defineProperty(CurrencyAdjustAmount, "defaultProps", {
  prefixCls: 'mkui-adjust-amount',
  value: {},
  amount: 0,
  ccyCode: 'CNY',
  precision: 2,
  min: -Infinity,
  max: Infinity,
  disabled: false
});

export default CurrencyAdjustAmount;
//# sourceMappingURL=CurrencyAdjustAmount.js.map
